// Totales vivos del ledger. Barra pegajosa al pie del panel de trabajo, igual
// que en Recepción Digital, pero sin el tramo de impuestos: en esta superficie
// el operador solo necesita FOB y conteo. El impuesto vive únicamente en el PDF.

const AnexoTotalsBar = ({ items = [] }) => {
  const totalFob = items.reduce(
    (s, it) => s + (Number(it.cantidad) || 0) * (Number(it.fob_unitario_usd) || 0),
    0
  );

  return (
    <div
      className="sticky bottom-0 flex items-center justify-between gap-4 border-t border-slate-200 bg-white px-4 py-2.5"
      role="status"
      aria-label="Totales del Anexo"
    >
      <span className="text-xs text-slate-500">
        {items.length} {items.length === 1 ? 'artículo' : 'artículos'}
      </span>
      <span className="font-mono text-sm font-bold text-slate-900">
        Total FOB USD$ {totalFob.toFixed(2)}
      </span>
    </div>
  );
};

export default AnexoTotalsBar;
